module.exports = __webpack_public_path__ + "img/imge6.76d67066.png";